import { MenuItem, SubMenu } from 'rc-menu'
import * as React from 'react'

import { NavItem } from '@joehua/buzz-cms-types'
import { MenuTheme } from '.'
import Link from '../Link'

export function renderItem({
  item,
  key,
  theme = {},
  onLinkClick,
}: {
  item: NavItem
  key: string
  theme?: MenuTheme
  onLinkClick?: (item: NavItem) => void
}) {
  if (Array.isArray(item.children) && item.children.length > 0) {
    return (
      <SubMenu
        key={key}
        className={theme.item}
        popupClassName={theme.popupClassName}
        // expandIcon={<span className="absolute right-1">></span>}
        title={
          item.to ? (
            <Link
              className={theme.itemLink}
              to={item.to}
              // @ts-ignore
              title={item.title}
              onClick={() => {
                if (onLinkClick) {
                  onLinkClick(item)
                }
              }}
            >
              {item.label}
            </Link>
          ) : (
            <span className={theme.itemLink}>{item.label}</span>
          )
        }
      >
        {item.children.map((child, childKey) =>
          renderItem({
            item: child,
            key: `${key}-${childKey}`,
            theme,
            onLinkClick: () => {
              if (onLinkClick) {
                onLinkClick(child)
              }
            },
          }),
        )}
      </SubMenu>
    )
  }
  return (
    <MenuItem key={key} className={theme.item}>
      <Link
        className={theme.itemLink}
        to={item.to}
        onClick={() => onLinkClick && onLinkClick(item)}
      >
        {item.label}
      </Link>
    </MenuItem>
  )
}
